import {
    PDP_PAGE_LOAD_READY,
    PDP_PAGE_LOAD_READY_SUCCESS,
    PDP_PAGE_LOAD_READY_ONRESET,
    PDP_CART_ADD_ANALYTICS,
    BUNDLE_PDP_CART_ADD_ANALYTICS,
    PDP_CART_UPDATE_ANALYTICS,
    PDP_REGISTRY_ADD_ANALYTICS,
    PDP_TOOL_CLICK_ANALYTICS,
    PDP_SAMEDAY_PICKUP_ANALYTICS,
    PDP_CHECK_AVAILABILITY_ANALYTICS,
    PDP_OPEN_MODAL_ANALYTICS,
    PDP_CHANGE_ZIPCODE_ANALYTICS,
    PDP_VIDEO_PLAYER_ANALYTICS,
    PDP_PRODUCT_OOS_ANALYTICS,
    PDP_CARE_PLAN_VIEW_ANALYTICS,
    PDP_CARE_PLAN_ACCEPT_ANALYTICS,
    PDP_FORM_ERROR_ANALYTICS,
    SEARCH_STORES_CLICK_EVENT,
    SELECT_OPTIONS_ANALYTICS,
    PDP_SHOP_THE_LOOK_READY,
    PDP_SHOP_THIS_LOOK_CLICK_EVENT,
    PDP_SHOP_THE_LOOK_MINI_PDP_CLICK_EVENT,
    PDP_SHOP_THE_COLLECTION_READY,
    PDP_ENABLE_VTO,
    PDP_PAGE_LOAD_PRODUCT_OOS,
    PDP_SHOP_THE_SET_READY,
    PDP_SHOP_THE_SET_CLICK_EVENT,
    PDP_PSC_AVAILABILITY,
} from '../actionTypes/AnalyticsActionTypes';

export const onPageReady = (payload) => ({
    type: PDP_PAGE_LOAD_READY,
    payload: {
        ...payload,
        sourceMiniPDP: false,
    },
});

export const pageLoadReadyScuccess = (payload) => ({
    type: PDP_PAGE_LOAD_READY_SUCCESS,
    payload,
});
export const pageLoadProductOOS = (payload) => ({
    type: PDP_PAGE_LOAD_PRODUCT_OOS,
    payload: {
        ...payload,
        sourceMiniPDP: false,
    },
});
export const restPageLoadReadyFlag = (payload) => ({
    type: PDP_PAGE_LOAD_READY_ONRESET,
    payload,
});

export const cartAddAnalytics = (payload) => ({
    type: PDP_CART_ADD_ANALYTICS,
    payload: {
        ...payload,
        sourceMiniPDP: false,
    },
});

export const bundleCartAddAnalytics = (payload) => ({
    type: BUNDLE_PDP_CART_ADD_ANALYTICS,
    payload,
});

export const cartUpdateAnalytics = (payload) => ({
    type: PDP_CART_UPDATE_ANALYTICS,
    payload: {
        ...payload,
        sourceMiniPDP: false,
    },
});

export const addToRegistryAnalytics = () => ({
    type: PDP_REGISTRY_ADD_ANALYTICS,
});

export const pdpToolClickAnalytics = (payload) => ({
    type: PDP_TOOL_CLICK_ANALYTICS,
    payload,
});

export const sameDayPickupAnalytics = () => ({
    type: PDP_SAMEDAY_PICKUP_ANALYTICS,
});

export const checkAvailabilityAnalytics = () => ({
    type: PDP_CHECK_AVAILABILITY_ANALYTICS,
});

export const openModalAnalytics = (payload) => ({
    type: PDP_OPEN_MODAL_ANALYTICS,
    payload,
});

export const changeZipcodeAnalytics = () => ({
    type: PDP_CHANGE_ZIPCODE_ANALYTICS,
});

export const videoPlayerAnalytics = (payload) => ({
    type: PDP_VIDEO_PLAYER_ANALYTICS,
    payload,
});

export const productOOSAnalytics = () => ({
    type: PDP_PRODUCT_OOS_ANALYTICS,
});

export const carePlanViewAnalytics = (payload) => ({
    type: PDP_CARE_PLAN_VIEW_ANALYTICS,
    payload,
});

export const carePlanAcceptAnalytics = (payload) => ({
    type: PDP_CARE_PLAN_ACCEPT_ANALYTICS,
    payload,
});

export const formErrorAnalytics = (payload) => ({
    type: PDP_FORM_ERROR_ANALYTICS,
    payload,
});

export const searchStoresAnalyticsAction = (payload) => ({
    type: SEARCH_STORES_CLICK_EVENT,
    payload,
});

export const selectOptionsAnalytics = () => ({
    type: SELECT_OPTIONS_ANALYTICS,
});

export const shopTheLookLoadSuccess = (payload) => ({
    type: PDP_SHOP_THE_LOOK_READY,
    payload,
});

export const shopThisLookClickEvent = (payload) => ({
    type: PDP_SHOP_THIS_LOOK_CLICK_EVENT,
    payload,
});

export const shopTheLookMiniPDPClickEvent = (payload) => ({
    type: PDP_SHOP_THE_LOOK_MINI_PDP_CLICK_EVENT,
    payload,
});

export const shopTheCollectionLoadSuccess = (payload) => ({
    type: PDP_SHOP_THE_COLLECTION_READY,
    payload,
});

export const shopTheSetLoadSuccess = (payload) => ({
    type: PDP_SHOP_THE_SET_READY,
    payload,
});

export const shopTheSetClickEvent = (payload) => ({
    type: PDP_SHOP_THE_SET_CLICK_EVENT,
    payload,
});

export const pdpEnableVto = () => ({
    type: PDP_ENABLE_VTO,
});

export const pdpPSCSKUAvailability = (payload) => ({
    type: PDP_PSC_AVAILABILITY,
    payload,
});
